import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".nobottom-library--VjmPS {\n  margin-bottom: 0;\n}\n\n.topRow-library--y-AVd {\n  display: flex;\n  justify-content: space-between;\n}";
var styles = {"nobottom":"nobottom-library--VjmPS","topRow":"topRow-library--y-AVd"};
styleInject(css_248z);

export { styles as default };
